export const Mail = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M14.6666 4.66663L8.68658 8.46663C8.48077 8.59558 8.2428 8.66397
       7.99992 8.66397C7.75704 8.66397 7.51907 8.59558 7.31325 8.46663L1.33325
        4.66663M2.66659 2.66663H13.3333C14.0696 2.66663 14.6666 3.26358 14.6666
        3.99996V12C14.6666 12.7363 14.0696 13.3333 13.3333 13.3333H2.66659C1.93021
        13.3333 1.33325 12.7363 1.33325 12V3.99996C1.33325 3.26358 1.93021 2.66663 2.66659 2.66663Z"
      stroke="#373D40"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)
